import { memo, useState } from 'react'

import Button from '~elements/Button'
import TrashIcon from '~icons/trash.svg'
import ConfirmModal from '~lib/ui-kit/ConfirmModal'
import useDeleteFeedbackPost from '~modules/feedbackTool/usecases/useDeleteFeedbackPost'

interface DeleteFeedbackPostButtonProps {
  feedbackPostId: string
}

function DeleteFeedbackPostButton({ feedbackPostId }: DeleteFeedbackPostButtonProps) {
  const [confirmDeleteModalOpened, setConfirmDeleteModalOpened] = useState(false)

  const [deleteFeedbackPost, { loading: deleteLoading }] = useDeleteFeedbackPost({
    onCompleted: () => {
      setConfirmDeleteModalOpened(false)
    },
  })

  const handleDeleteClick = () => {
    setConfirmDeleteModalOpened(true)
  }

  const handleDeleteSubmit = () => {
    deleteFeedbackPost(feedbackPostId)
  }

  const handleCloseDeleteModal = () => {
    setConfirmDeleteModalOpened(false)
  }

  return (
    <>
      <Button variant="plain" icon={<TrashIcon />} onClick={handleDeleteClick} />

      <ConfirmModal
        opened={confirmDeleteModalOpened}
        submitLoading={deleteLoading}
        overlayVariant="blur"
        label="Delete product idea?"
        description="Are you sure you want to remove this product idea?"
        variant="danger"
        submitText="Remove"
        closeText="Cancel"
        onSubmit={handleDeleteSubmit}
        onClose={handleCloseDeleteModal}
        onEscapePress={handleCloseDeleteModal}
        onOverlayClick={handleCloseDeleteModal}
      />
    </>
  )
}

export default memo(DeleteFeedbackPostButton)
